export default __webpack_public_path__ + "static/thumb-1-2f2bec6f1057f6fc0dc0fef0555b3d40.jpg";